
import BrifecaseCross from "../../../assets/duotone/BrifecaseCross.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function BrifecaseCrossIcon({ className, dataTestid = "BrifecaseCrossIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <BrifecaseCross data-testid={dataTestid} className={classes} {...rest} />
  );
}
